import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../hoc/compose';
import Icon from '../icons/infoIcon.svg.js';
import ErrorIcon from '../icons/inputValidationError.svg.js';
import ErrorIconSmall from '../icons/inputValidationErrorSmall.svg.js';
import Tooltip from '../tooltip/tooltip';
import { CONSTS } from '../../util/tooltipPosition';
import { dataHooks } from './constants';

var getTooltipChild = function getTooltipChild(str, props, tr) {
  return str ? /*#__PURE__*/React.createElement('div', _.defaults({
    key: props.className
  }, props), tr(str)) : null;
};

var getTooltipIllustrationChild = function getTooltipIllustrationChild(illustration, props) {
  return illustration ? /*#__PURE__*/React.createElement('div', _.defaults({
    key: props.className
  }, props), illustration) : null;
};

var TooltipContent = function TooltipContent(props) {
  return /*#__PURE__*/React.createElement('span', {
    className: 'info-icon-content'
  }, [getTooltipChild(props.title, {
    className: 'info-icon-title'
  }, props.translateIfNeeded), getTooltipIllustrationChild(props.illustration, {
    className: 'info-icon-illustration',
    onClick: props.onIllustrationClick
  }), getTooltipChild(props.text, {
    className: 'info-icon-text'
  }, props.translateIfNeeded), getTooltipChild(props.linkText, {
    className: 'info-icon-link',
    onClick: props.onLinkClick
  }, props.translateIfNeeded)]);
};

var infoIcon = /*#__PURE__*/function (_React$Component) {
  _inherits(infoIcon, _React$Component);

  var _super = _createSuper(infoIcon);

  function infoIcon(props) {
    var _this;

    _classCallCheck(this, infoIcon);

    _this = _super.call(this, props);

    _this.getTooltipContent = function () {
      return props.tooltipCustomContent || /*#__PURE__*/React.createElement(TooltipContent, _this.props);
    };

    return _this;
  }

  _createClass(infoIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Tooltip, _.assign({}, {
        className: 'info-icon-tooltip' + (this.props.tooltipClassName ? " ".concat(this.props.tooltipClassName) : '')
      }, this._getTooltipProps()), /*#__PURE__*/React.createElement("span", {
        className: this.props.getClassName('control-info-icon') + (this.props.error ? ' error' : '') + (this.props.small ? ' small' : ''),
        "data-hook": dataHooks.infoIconRoot,
        onClick: this.props.onClick
      }, !this.props.customSymbol && !this.props.error ? /*#__PURE__*/React.createElement(Icon, {
        key: "icon"
      }) : null, !this.props.small && !this.props.customSymbol && this.props.error ? /*#__PURE__*/React.createElement(ErrorIcon, {
        key: "icon"
      }) : null, this.props.small && !this.props.customSymbol && this.props.error ? /*#__PURE__*/React.createElement(ErrorIconSmall, {
        key: "icon"
      }) : null, this.props.customSymbol));
    }
  }, {
    key: "_getTooltipProps",
    value: function _getTooltipProps() {
      return {
        automationId: this.props.automationId,
        dataHook: this.props.dataHook,
        content: this.getTooltipContent(),
        interactive: _.isFunction(this.props.onLinkClick) || _.isFunction(this.props.onIllustrationClick),
        alignment: this.props.alignment,
        disabled: !(this.props.text || this.props.title || this.props.tooltipCustomContent),
        marginLeft: this.props.tooltipMarginLeft,
        marginRight: this.props.tooltipMarginRight,
        marginTop: this.props.tooltipMarginTop,
        marginBottom: this.props.tooltipMarginBottom,
        maxWidth: this.props.tooltipMaxWidth,
        closeOnContentMouseClick: this.props.closeOnContentMouseClick,
        onOpen: this.props.onTooltipOpen,
        onContentMouseClick: this.props.onTooltipClick
      };
    }
  }]);

  return infoIcon;
}(React.Component);

infoIcon.displayName = 'InfoIcon';
infoIcon.propTypes = {
  /** Align the tooltip: 'TOP','BOTTOM','LEFT' or 'RIGHT' */
  alignment: PropTypes.oneOf(_.values(CONSTS.ALIGNMENT)),

  /** Sets the maximum width of the tooltip */
  tooltipMaxWidth: PropTypes.number,

  /** Override the default info icon */
  customSymbol: PropTypes.element,

  /** Should close tooltip on clicking its content */
  closeOnContentMouseClick: PropTypes.bool,

  /** Callback function, triggered on icon click */
  onClick: PropTypes.func,

  /** Set the icons with error appearance */
  error: PropTypes.bool,

  /** Set the icon to small size */
  small: PropTypes.bool,

  /** Title to be displayed in the tooltip */
  title: PropTypes.string,

  /** Text content to be displayed in the tooltip */
  text: PropTypes.string,

  /** Set text for a link at the end of the tooltip content */
  linkText: PropTypes.string,

  /** Callback function, triggered on text link click */
  onLinkClick: PropTypes.func,

  /** Set illustration in the tooltip */
  illustration: PropTypes.element,

  /** Callback function, triggered on illustration click */
  onIllustrationClick: PropTypes.func,
  tooltipMarginLeft: PropTypes.number,
  tooltipMarginRight: PropTypes.number,
  tooltipMarginTop: PropTypes.number,
  tooltipMarginBottom: PropTypes.number,
  tooltipCustomContent: PropTypes.element,

  /** Add class to the tooltip */
  tooltipClassName: PropTypes.string,

  /** Callback function, triggered on tooltip open */
  onTooltipOpen: PropTypes.func,

  /** Callback function, triggered on tooltip click */
  onTooltipClick: PropTypes.func
};
infoIcon.defaultProps = {
  alignment: CONSTS.ALIGNMENT.TOP,
  tooltipMaxWidth: 240,
  small: false
};
export default compose(infoIcon);